// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditTag } from '../../forms/FormEditTag/FormEditTag';

// props
export interface DialogEditTagProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditTag = ({ isOpen, onClose, onSuccess }: DialogEditTagProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('saveTag'),
					loading: isLoading,
					form: 'form-edit-tag',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={400}
			onClose={onClose}
			title={{
				children: t('editTag'),
				variant: 'h3',
			}}>
			<FormEditTag onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
